import { IAdvancedReports } from '../domains/Reports';
import { api } from './api';

class ReportsService {
  private apiService = api;

  public async getAdvancedReports() {
    return this.apiService.get<IAdvancedReports>('reports/advanced');
  }
}

export { ReportsService };
